import type { ReactNode } from 'react';

export interface AuthErrorProps {
  children?: ReactNode;
}

export default function AuthError({ children }: AuthErrorProps) {
  if (!children) return null;
  return (
    <div
      role="alert"
      aria-live="polite"
      style={{
        background: 'var(--nrg-color-critical-bg)',
        color: 'var(--nrg-color-critical)',
        border: '1px solid var(--nrg-color-critical-border)',
        borderRadius: 'var(--nrg-radius-sm)',
        padding: 'var(--nrg-space-3) var(--nrg-space-4)',
        fontSize: 'var(--nrg-font-size-body-sm)',
        lineHeight: 'var(--nrg-line-height-body-sm)',
      }}
    >
      {children}
    </div>
  );
}
